import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from '../Context/TranslationContext';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const Gallery = () => {
  const { isTamil } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeSection, setActiveSection] = useState('southZone');

  const translations = {
    title: {
      en: "Scout Gallery",
      ta: "சாரணர் படத்தொகுப்பு"
    },
    subtitle: {
      en: "Capturing the journey of scouting through moments and memories",
      ta: "தருணங்கள் மற்றும் நினைவுகள் மூலம் சாரணர் பயணத்தைப் பிடித்தல்"
    },
    sections: {
      southZone: {
        en: "South Zone Gathering",
        ta: "தென் மண்டல திரளணி",
      },
      eastZone: {
        en: "East Zone Gathering",
        ta: "கிழக்கு மண்டல திரளணி",
      },
      republicDay: {
        en: "74th Republic Day Celebration",
        ta: "74வது குடியரசு தின விழா",
      },
      northZone: {
        en: "State Special Rally North Zone",
        ta: "மாநில சிறப்பு திரளணி வடக்கு மண்டலம்",
      },
      world: {
        en: "World Thought Day 2023",
        ta: "உலக சிந்தனை நாள் -2023",
      },
      leadershipCamp: {
        en: "Team Leaders Training Camp",
        ta: "அணித் தலைவர்கள் பயிற்சி முகாம்",
      },
      presidentAward: {
        en: "President Award Certificate Test Camp 2023",
        ta: "குடியரசுத் தலைவர் விருதுச் சான்றிதழ் சோதனை முகாம் 2023",
      },
      chaturthaCharan: {
        en: "Chaturtha Charan / Heerak Bunk Test Camps",
        ta: "சதுர்த்த சரண் / ஹீரக் பங்க் தேர்வு முகாம்கள்",
      },
      independenceDay: {
        en: "77th Independence Day Celebration 2023",
        ta: "77வது சுதந்திர தின விழா – 2023",
      },
      cubBulbul: {
        en: "State Level Cub/Bulbul Celebration 2023",
        ta: "மாநில அளவிலான குருளையர் நீலப்பறவையர் கொண்டாட்டம் - 2023",
      },
      peaceDayCelebration: {
        en: "International Peace Day",
        ta: "சர்வதேச அமைதி தினம்",
      },
      virtualRally: {
        en: "Tamil Nadu State Virtual Rally",
        ta: "தமிழ்நாடு முழுவதும் வான்வழி மற்றும் இணையவழி திரளணி",
      },
      zonalCompetitions: {
        en: "Tamil Nadu Zonal Cub/Bulbul Competitions",
        ta: "தமிழ்நாடு முழுவதும் மண்டல அளவிலான குருளையர் நீலப்பறவையர் போட்டிகள்",
      },
      foundersDay: {
        en: "74th Founders Day Celebration",
        ta: "74வது நிறுவனர் நாள் கொண்டாட்டம்",
      },
      thoughtDayRally: {
        en: "Thought Day Rally",
        ta: "சிந்தனை நாள் பேரணி",
      },
      competitions: {
        en: "Cub/Bulbul Competitions",
        ta: "குருளையர் நீலப்பறவையர் போட்டிகள்",
      },
      zonalLeaders: {
        en: "Zonal Team Leaders Rally",
        ta: "மண்டல அளவிலான அணித் தலைவர்கள் திரளணி",
      },
      culturalRally: {
        en: "International Cultural Rally",
        ta: "சர்வதேச கலாச்சார பெருந்திரளணி",
      },
      genesis: {
        en: "Genesis 2023 (Part-III)",
        ta: "ஜெனிசிஸ் 2023 (தொகுப்பு-III)",
      }
    },
    close: {
      en: "Close",
      ta: "மூடு"
    }
  };

  const gallerySections = {
    southZone: [
      { type: 'image', src: '/Images/gallery/southzone1.png', alt: 'தென் மண்டல திரளணி 1' },
      { type: 'image', src: '/Images/gallery/southzone2.png', alt: 'தென் மண்டல திரளணி 2' },
      { type: 'image', src: '/Images/gallery/southzone3.png', alt: 'தென் மண்டல திரளணி 3' },
      { type: 'image', src: '/Images/gallery/southzone4.png', alt: 'தென் மண்டல திரளணி 4' },
      { type: 'image', src: '/Images/gallery/southzone5.png', alt: 'தென் மண்டல திரளணி 5' },
      { type: 'image', src: '/Images/gallery/southzone6.png', alt: 'தென் மண்டல திரளணி 6' },
      { type: 'image', src: '/Images/gallery/southzone7.png', alt: 'தென் மண்டல திரளணி 7' },
      { type: 'image', src: '/Images/gallery/southzone8.png', alt: 'தென் மண்டல திரளணி 8' }
    ],
    
    eastZone: [
      { type: 'image', src: '/Images/gallery/eastzone1.png', alt: 'கிழக்கு மண்டல திரளணி 1' },
      { type: 'image', src: '/Images/gallery/eastzone2.png', alt: 'கிழக்கு மண்டல திரளணி 2' },
      { type: 'image', src: '/Images/gallery/eastzone3.png', alt: 'கிழக்கு மண்டல திரளணி 3' },
      { type: 'image', src: '/Images/gallery/eastzone4.png', alt: 'கிழக்கு மண்டல திரளணி 4' },
      { type: 'image', src: '/Images/gallery/eastzone5.png', alt: 'கிழக்கு மண்டல திரளணி 5' },
      { type: 'image', src: '/Images/gallery/eastzone6.png', alt: 'கிழக்கு மண்டல திரளணி 6' },
      { type: 'image', src: '/Images/gallery/eastzone7.png', alt: 'கிழக்கு மண்டல திரளணி 7' },
      { type: 'image', src: '/Images/gallery/eastzone8.png', alt: 'கிழக்கு மண்டல திரளணி 8' },
      { type: 'image', src: '/Images/gallery/eastzone9.png', alt: 'கிழக்கு மண்டல திரளணி 9' }
    ],
    
    republicDay: [
      { type: 'image', src: '/Images/gallery/republicday1.png', alt: '74வது குடியரசு தின விழா 1' },
      { type: 'image', src: '/Images/gallery/republicday2.png', alt: '74வது குடியரசு தின விழா 2' },
      { type: 'image', src: '/Images/gallery/republicday3.png', alt: '74வது குடியரசு தின விழா 3' },
      { type: 'image', src: '/Images/gallery/republicday4.png', alt: '74வது குடியரசு தின விழா 4' },
      { type: 'image', src: '/Images/gallery/republicday5.png', alt: '74வது குடியரசு தின விழா 5' },
      { type: 'image', src: '/Images/gallery/republicday6.png', alt: '74வது குடியரசு தின விழா 6' },
      { type: 'image', src: '/Images/gallery/republicday7.png', alt: '74வது குடியரசு தின விழா 7' },
      { type: 'image', src: '/Images/gallery/republicday8.png', alt: '74வது குடியரசு தின விழா 8' },
      { type: 'image', src: '/Images/gallery/republicday9.png', alt: '74வது குடியரசு தின விழா 9' },
      { type: 'image', src: '/Images/gallery/republicday10.png', alt: '74வது குடியரசு தின விழா 10' },
      { type: 'image', src: '/Images/gallery/republicday11.png', alt: '74வது குடியரசு தின விழா 11' },
      { type: 'image', src: '/Images/gallery/republicday12.png', alt: '74வது குடியரசு தின விழா 12' },
      { type: 'image', src: '/Images/gallery/republicday13.png', alt: '74வது குடியரசு தின விழா 13' }
    ],
    
    northZone: [
      { type: 'image', src: '/Images/gallery/northzone1.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 1' },
      { type: 'image', src: '/Images/gallery/northzone2.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 2' },
      { type: 'image', src: '/Images/gallery/northzone3.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 3' },
      { type: 'image', src: '/Images/gallery/northzone4.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 4' },
      { type: 'image', src: '/Images/gallery/northzone5.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 5' },
      { type: 'image', src: '/Images/gallery/northzone6.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 6' },
      { type: 'image', src: '/Images/gallery/northzone7.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 7' },
      { type: 'image', src: '/Images/gallery/northzone8.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 8' },
      { type: 'image', src: '/Images/gallery/northzone9.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 9' },
      { type: 'image', src: '/Images/gallery/northzone10.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 10' },
      { type: 'image', src: '/Images/gallery/northzone11.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 11' },
      { type: 'image', src: '/Images/gallery/northzone12.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 12' },
      { type: 'image', src: '/Images/gallery/northzone13.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 13' },
      { type: 'image', src: '/Images/gallery/northzone14.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 14' },
      { type: 'image', src: '/Images/gallery/northzone15.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 15' },
      { type: 'image', src: '/Images/gallery/northzone16.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 16' },
      { type: 'image', src: '/Images/gallery/northzone17.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 17' },
      { type: 'image', src: '/Images/gallery/northzone18.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 18' },
      { type: 'image', src: '/Images/gallery/northzone19.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 19' },
      { type: 'image', src: '/Images/gallery/northzone20.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 20' },
      { type: 'image', src: '/Images/gallery/northzone21.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 21' },
      { type: 'image', src: '/Images/gallery/northzone22.png', alt: 'மாநில சிறப்பு திரளணி வடக்கு மண்டலம் 22' }
    ],
    
    world: [
      { type: 'image', src: '/Images/gallery/world1.png', alt: 'உலக சிந்தனை நாள் -2023 1' },
      { type: 'image', src: '/Images/gallery/world2.png', alt: 'உலக சிந்தனை நாள் -2023 2' },
      { type: 'image', src: '/Images/gallery/world3.png', alt: 'உலக சிந்தனை நாள் -2023 3' },
      { type: 'image', src: '/Images/gallery/world4.png', alt: 'உலக சிந்தனை நாள் -2023 4' },
      { type: 'image', src: '/Images/gallery/world5.png', alt: 'உலக சிந்தனை நாள் -2023 5' },
      { type: 'image', src: '/Images/gallery/world6.png', alt: 'உலக சிந்தனை நாள் -2023 6' },
      { type: 'image', src: '/Images/gallery/world7.png', alt: 'உலக சிந்தனை நாள் -2023 7' },
      { type: 'image', src: '/Images/gallery/world8.png', alt: 'உலக சிந்தனை நாள் -2023 8' },
      { type: 'image', src: '/Images/gallery/world9.png', alt: 'உலக சிந்தனை நாள் -2023 9' }
    ],
    
    leadershipCamp: [
      { type: 'image', src: '/Images/gallery/leader1.png', alt: 'அணித் தலைவர்கள் பயிற்சி முகாம் 1' },
      { type: 'image', src: '/Images/gallery/leader2.png', alt: 'அணித் தலைவர்கள் பயிற்சி முகாம் 2' },
      { type: 'image', src: '/Images/gallery/leader3.png', alt: 'அணித் தலைவர்கள் பயிற்சி முகாம் 3' },
      { type: 'image', src: '/Images/gallery/leader4.png', alt: 'அணித் தலைவர்கள் பயிற்சி முகாம் 4' },
      { type: 'image', src: '/Images/gallery/leader5.png', alt: 'அணித் தலைவர்கள் பயிற்சி முகாம் 5' }
     
    ],
    
    presidentAward: [
      { type: 'image', src: '/Images/gallery/president1.png', alt: 'குடியரசுத் தலைவர் விருதுச் சான்றிதழ் சோதனை முகாம் 1' },
      { type: 'image', src: '/Images/gallery/president2.png', alt: 'குடியரசுத் தலைவர் விருதுச் சான்றிதழ் சோதனை முகாம் 2' },
      { type: 'image', src: '/Images/gallery/president3.png', alt: 'குடியரசுத் தலைவர் விருதுச் சான்றிதழ் சோதனை முகாம் 3' },
      { type: 'image', src: '/Images/gallery/president4.png', alt: 'குடியரசுத் தலைவர் விருதுச் சான்றிதழ் சோதனை முகாம் 4' },
      { type: 'image', src: '/Images/gallery/president5.png', alt: 'குடியரசுத் தலைவர் விருதுச் சான்றிதழ் சோதனை முகாம் 5' },
      { type: 'image', src: '/Images/gallery/president6.png', alt: 'குடியரசுத் தலைவர் விருதுச் சான்றிதழ் சோதனை முகாம் 6' },
      { type: 'image', src: '/Images/gallery/president7.png', alt: 'குடியரசுத் தலைவர் விருதுச் சான்றிதழ் சோதனை முகாம் 7' }
     
    ],
  
    chaturthaCharan: [
      { type: 'image', src: '/Images/gallery/chatur1.png', alt: 'சதுர்த்த சரண் / ஹீரக் பங்க் தேர்வு முகாம்கள் 1' },
      { type: 'image', src: '/Images/gallery/chatur2.png', alt: 'சதுர்த்த சரண் / ஹீரக் பங்க் தேர்வு முகாம்கள் 2' },
      { type: 'image', src: '/Images/gallery/chatur3.png', alt: 'சதுர்த்த சரண் / ஹீரக் பங்க் தேர்வு முகாம்கள் 3' },
      { type: 'image', src: '/Images/gallery/chatur4.png', alt: 'சதுர்த்த சரண் / ஹீரக் பங்க் தேர்வு முகாம்கள் 4' },
      { type: 'image', src: '/Images/gallery/chatur5.png', alt: 'சதுர்த்த சரண் / ஹீரக் பங்க் தேர்வு முகாம்கள் 5' },
      { type: 'image', src: '/Images/gallery/chatur6.png', alt: 'சதுர்த்த சரண் / ஹீரக் பங்க் தேர்வு முகாம்கள் 6' }
    ],
  
    independenceDay: [
      { type: 'image', src: '/Images/gallery/independence1.png', alt: '77வது சுதந்திர தின விழா – 2023 1' },
      { type: 'image', src: '/Images/gallery/independence2.png', alt: '77வது சுதந்திர தின விழா – 2023 2' },
      { type: 'image', src: '/Images/gallery/independence3.png', alt: '77வது சுதந்திர தின விழா – 2023 3' },
      { type: 'image', src: '/Images/gallery/independence4.png', alt: '77வது சுதந்திர தின விழா – 2023 4' },
      { type: 'image', src: '/Images/gallery/independence5.png', alt: '77வது சுதந்திர தின விழா – 2023 5' },
      { type: 'image', src: '/Images/gallery/independence6.png', alt: '77வது சுதந்திர தின விழா – 2023 6' },
      { type: 'image', src: '/Images/gallery/independence7.png', alt: '77வது சுதந்திர தின விழா – 2023 7' },
      { type: 'image', src: '/Images/gallery/independence8.png', alt: '77வது சுதந்திர தின விழா – 2023 8' },
      { type: 'image', src: '/Images/gallery/independence9.png', alt: '77வது சுதந்திர தின விழா – 2023 9' },
      { type: 'image', src: '/Images/gallery/independence10.png', alt: '77வது சுதந்திர தின விழா – 2023 10' }
    
    ],
  
    cubBulbul: [
      { type: 'image', src: '/Images/gallery/cub1.png', alt: 'மாநில அளவிலான குருளையர் நீலப்பறவையர் கொண்டாட்டம் - 2023 1' },
      { type: 'image', src: '/Images/gallery/cub2.png', alt: 'மாநில அளவிலான குருளையர் நீலப்பறவையர் கொண்டாட்டம் - 2023 2' },
      { type: 'image', src: '/Images/gallery/cub3.png', alt: 'மாநில அளவிலான குருளையர் நீலப்பறவையர் கொண்டாட்டம் - 2023 3' },
      { type: 'image', src: '/Images/gallery/cub4.png', alt: 'மாநில அளவிலான குருளையர் நீலப்பறவையர் கொண்டாட்டம் - 2023 4' },
      { type: 'image', src: '/Images/gallery/cub5.png', alt: 'மாநில அளவிலான குருளையர் நீலப்பறவையர் கொண்டாட்டம் - 2023 5' }
    ],
  
    peaceDayCelebration: [
      { type: 'image', src: '/Images/gallery/peace1.png', alt: 'சர்வதேச அமைதி தினம் 1' },
      { type: 'image', src: '/Images/gallery/peace2.png', alt: 'சர்வதேச அமைதி தினம் 2' },
      { type: 'image', src: '/Images/gallery/peace3.png', alt: 'சர்வதேச அமைதி தினம் 3' },
      { type: 'image', src: '/Images/gallery/peace4.png', alt: 'சர்வதேச அமைதி தினம் 4' }
    ],
  
    virtualRally: [
      { type: 'image', src: '/Images/gallery/rally1.png', alt: 'தமிழ்நாடு முழுவதும் வான்வழி மற்றும் இணையவழி திரளணி 1' },
      { type: 'image', src: '/Images/gallery/rally2.png', alt: 'தமிழ்நாடு முழுவதும் வான்வழி மற்றும் இணையவழி திரளணி 2' },
      { type: 'image', src: '/Images/gallery/rally3.png', alt: 'தமிழ்நாடு முழுவதும் வான்வழி மற்றும் இணையவழி திரளணி 3' },
      { type: 'image', src: '/Images/gallery/rally4.png', alt: 'தமிழ்நாடு முழுவதும் வான்வழி மற்றும் இணையவழி திரளணி 4' },
      { type: 'image', src: '/Images/gallery/rally5.png', alt: 'தமிழ்நாடு முழுவதும் வான்வழி மற்றும் இணையவழி திரளணி 5' }
    ],
  
    zonalCompetitions: [
      { type: 'image', src: '/Images/gallery/zonal1.png', alt: 'தமிழ்நாடு முழுவதும் மண்டல அளவிலான குருளையர் நீலப்பறவையர் போட்டிகள் 1' },
      { type: 'image', src: '/Images/gallery/zonal2.png', alt: 'தமிழ்நாடு முழுவதும் மண்டல அளவிலான குருளையர் நீலப்பறவையர் போட்டிகள் 2' },
      { type: 'image', src: '/Images/gallery/zonal3.png', alt: 'தமிழ்நாடு முழுவதும் மண்டல அளவிலான குருளையர் நீலப்பறவையர் போட்டிகள் 3' },
      { type: 'image', src: '/Images/gallery/zonal4.png', alt: 'தமிழ்நாடு முழுவதும் மண்டல அளவிலான குருளையர் நீலப்பறவையர் போட்டிகள் 4' },
      { type: 'image', src: '/Images/gallery/zonal5.png', alt: 'தமிழ்நாடு முழுவதும் மண்டல அளவிலான குருளையர் நீலப்பறவையர் போட்டிகள் 5' }
    ],
  
    foundersDay: [
      { type: 'image', src: '/Images/gallery/founders1.png', alt: '74வது நிறுவனர் நாள் கொண்டாட்டம் 1' },
      { type: 'image', src: '/Images/gallery/founders2.png', alt: '74வது நிறுவனர் நாள் கொண்டாட்டம் 2' },
      { type: 'image', src: '/Images/gallery/founders3.png', alt: '74வது நிறுவனர் நாள் கொண்டாட்டம் 3' },
      { type: 'image', src: '/Images/gallery/founders4.png', alt: '74வது நிறுவனர் நாள் கொண்டாட்டம் 4' },
      { type: 'image', src: '/Images/gallery/founders5.png', alt: '74வது நிறுவனர் நாள் கொண்டாட்டம் 5' }
    ],
  
    thoughtDayRally: [
      { type: 'image', src: '/Images/gallery/thought1.png', alt: 'சிந்தனை நாள் பேரணி 1' },
      { type: 'image', src: '/Images/gallery/thought2.png', alt: 'சிந்தனை நாள் பேரணி 2' },
      { type: 'image', src: '/Images/gallery/thought3.png', alt: 'சிந்தனை நாள் பேரணி 3' },
      { type: 'image', src: '/Images/gallery/thought4.png', alt: 'சிந்தனை நாள் பேரணி 4' },
      { type: 'image', src: '/Images/gallery/thought5.png', alt: 'சிந்தனை நாள் பேரணி 5' }
      
    ],
  
    competitions: [
      { type: 'image', src: '/Images/gallery/competitions1.png', alt: 'குருளையர் நீலப்பறவையர் போட்டிகள் 1' },
      { type: 'image', src: '/Images/gallery/competitions2.png', alt: 'குருளையர் நீலப்பறவையர் போட்டிகள் 2' },
      { type: 'image', src: '/Images/gallery/competitions3.png', alt: 'குருளையர் நீலப்பறவையர் போட்டிகள் 3' },
      { type: 'image', src: '/Images/gallery/competitions4.png', alt: 'குருளையர் நீலப்பறவையர் போட்டிகள் 4' },
      { type: 'image', src: '/Images/gallery/competitions5.png', alt: 'குருளையர் நீலப்பறவையர் போட்டிகள் 5' },
      { type: 'image', src: '/Images/gallery/competitions6.png', alt: 'குருளையர் நீலப்பறவையர் போட்டிகள் 6' }
    ],
  
    zonalLeaders: [
      { type: 'image', src: '/Images/gallery/zonalleaders1.png', alt: 'மண்டல அளவிலான அணித் தலைவர்கள் திரளணி 1' },
      { type: 'image', src: '/Images/gallery/zonalleaders2.png', alt: 'மண்டல அளவிலான அணித் தலைவர்கள் திரளணி 2' },
      { type: 'image', src: '/Images/gallery/zonalleaders3.png', alt: 'மண்டல அளவிலான அணித் தலைவர்கள் திரளணி 3' },
      { type: 'image', src: '/Images/gallery/zonalleaders4.png', alt: 'மண்டல அளவிலான அணித் தலைவர்கள் திரளணி 4' },
      { type: 'image', src: '/Images/gallery/zonalleaders5.png', alt: 'மண்டல அளவிலான அணித் தலைவர்கள் திரளணி 5' },
      { type: 'image', src: '/Images/gallery/zonalleaders6.png', alt: 'மண்டல அளவிலான அணித் தலைவர்கள் திரளணி 6' }
    ],
  
    culturalRally: [
      { type: 'image', src: '/Images/gallery/cultural1.png', alt: 'சர்வதேச கலாச்சார பெருந்திரளணி 1' },
      { type: 'image', src: '/Images/gallery/cultural2.png', alt: 'சர்வதேச கலாச்சார பெருந்திரளணி 2' },
      { type: 'image', src: '/Images/gallery/cultural3.png', alt: 'சர்வதேச கலாச்சார பெருந்திரளணி 3' },
      { type: 'image', src: '/Images/gallery/cultural4.png', alt: 'சர்வதேச கலாச்சார பெருந்திரளணி 4' },
      { type: 'image', src: '/Images/gallery/cultural5.png', alt: 'சர்வதேச கலாச்சார பெருந்திரளணி 5' },
      { type: 'image', src: '/Images/gallery/cultural6.png', alt: 'சர்வதேச கலாச்சார பெருந்திரளணி 6' },
      { type: 'image', src: '/Images/gallery/cultural7.png', alt: 'சர்வதேச கலாச்சார பெருந்திரளணி 7' },
      { type: 'image', src: '/Images/gallery/cultural8.png', alt: 'சர்வதேச கலாச்சார பெருந்திரளணி 8' }
    ],
  
    genesis: [
      { type: 'image', src: '/Images/gallery/genesis1.png', alt: 'ஜெனிசிஸ் 2023 (தொகுப்பு-III) 1' },
      { type: 'image', src: '/Images/gallery/genesis2.png', alt: 'ஜெனிசிஸ் 2023 (தொகுப்பு-III) 2' },
      { type: 'image', src: '/Images/gallery/genesis3.png', alt: 'ஜெனிசிஸ் 2023 (தொகுப்பு-III) 3' },
      { type: 'image', src: '/Images/gallery/genesis4.png', alt: 'ஜெனிசிஸ் 2023 (தொகுப்பு-III) 4' }
    ]
  };
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const nextImage = (e) => {
    e.stopPropagation();
    const currentSection = gallerySections[activeSection];
    setCurrentImageIndex((prev) => 
      prev === currentSection.length - 1 ? 0 : prev + 1
    );
  };

  const previousImage = (e) => {
    e.stopPropagation();
    const currentSection = gallerySections[activeSection];
    setCurrentImageIndex((prev) => 
      prev === 0 ? currentSection.length - 1 : prev - 1
    );
  };

  // Handle keyboard navigation
  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (selectedImage) {
        if (e.key === 'Escape') {
          setSelectedImage(null);
        } else if (e.key === 'ArrowRight') {
          nextImage(e);
        } else if (e.key === 'ArrowLeft') {
          previousImage(e);
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, activeSection]);

  return (
    <div className="min-h-screen bg-[#FDFBF8]">
      {/* Hero Section */}
      <div className="relative h-[40vh] min-h-[400px] bg-gradient-to-br from-[#2C251D] to-[#8A7968] overflow-hidden">
        <div className="absolute inset-0 bg-black/30" />
        <div className="absolute inset-0 flex items-center justify-center text-center p-6">
          <div>
            <motion.h1 
              className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 mt-10"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              {translations.title[isTamil ? 'ta' : 'en']}
            </motion.h1>
            <motion.p 
              className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              {translations.subtitle[isTamil ? 'ta' : 'en']}
            </motion.p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-[2000px] mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Section Navigation */}
        <motion.div 
  className="mb-12"
  initial={{ opacity: 0, y: 20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.6 }}
>
  <div className="flex overflow-x-auto pb-4 hide-scrollbar">
    <div className="flex gap-4">
      {Object.keys(translations.sections).map((section) => (
        <motion.button
          key={section}
          onClick={() => {
            setActiveSection(section);
            setCurrentImageIndex(0);
          }}
          className={`
            whitespace-nowrap px-6 py-3 rounded-full text-sm font-medium
            transition-all duration-300 ease-in-out relative
            ${activeSection === section 
              ? 'bg-[#8A7968] text-white shadow-lg' 
              : 'bg-white text-[#2C251D] hover:bg-[#F5F1EA]'
            }
          `}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          {translations.sections[section][isTamil ? 'ta' : 'en']}
        </motion.button>
      ))}
    </div>
  </div>
</motion.div>

        {/* Gallery Grid */}
        <AnimatePresence mode="wait">
          <motion.div
            key={activeSection}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            {gallerySections[activeSection].map((item, index) => (
              <motion.div
                key={index}
                className="aspect-[4/3] rounded-xl overflow-hidden bg-white shadow-md hover:shadow-xl transition-all duration-300"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <motion.div 
                  className="w-full h-full relative cursor-pointer group"
                  whileHover={{ scale: 1.02 }}
                  onClick={() => {
                    setSelectedImage(item);
                    setCurrentImageIndex(index);
                  }}
                >
                  <img
                    src={item.src}
                    alt={item.alt}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 
                                transition-opacity duration-300 flex items-center justify-center">
                    <span className="text-white text-sm font-medium transform translate-y-4 
                                   group-hover:translate-y-0 transition-transform duration-300">
                      Click to View
                    </span>
                  </div>
                </motion.div>
              </motion.div>
            ))}
          </motion.div>
        </AnimatePresence>
      </div>

{/* Lightbox */}
<AnimatePresence>
  {selectedImage && (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 bg-black/95 backdrop-blur-sm"
      onClick={() => setSelectedImage(null)}
    >
      <div className="absolute inset-0 flex items-center justify-center p-4">
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          className="relative w-full md:max-w-[50%] max-h-[80vh]" // Only apply 50% width on medium screens and up
          onClick={(e) => e.stopPropagation()}
        >
          <img
            src={gallerySections[activeSection][currentImageIndex].src}
            alt={gallerySections[activeSection][currentImageIndex].alt}
            className="w-full h-full object-contain rounded-lg"
          />
          
          {/* Navigation Buttons - Adjusted for mobile */}
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-2 right-2 md:top-4 md:right-4 bg-white/10 hover:bg-white/20 text-white p-2 
                     rounded-full backdrop-blur-sm transition-all duration-300 z-10"
          >
            <X className="w-5 h-5 md:w-6 md:h-6" />
          </button>

          <button
            onClick={previousImage}
            className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/20 
                     text-white p-2 rounded-full backdrop-blur-sm transition-all duration-300 z-10"
          >
            <ChevronLeft className="w-5 h-5 md:w-6 md:h-6" />
          </button>

          <button
            onClick={nextImage}
            className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/20 
                     text-white p-2 rounded-full backdrop-blur-sm transition-all duration-300 z-10"
          >
            <ChevronRight className="w-5 h-5 md:w-6 md:h-6" />
          </button>

          {/* Image Counter - Adjusted for mobile */}
          <div className="absolute bottom-2 md:bottom-4 left-1/2 -translate-x-1/2 bg-white/10 text-white 
                       px-3 py-1 md:px-4 md:py-2 rounded-full backdrop-blur-sm text-sm md:text-base">
            {currentImageIndex + 1} / {gallerySections[activeSection].length}
          </div>
        </motion.div>
      </div>
    </motion.div>
  )}
</AnimatePresence>

      {/* CSS for hiding scrollbar */}
      <style jsx global>{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
};

export default Gallery;